export const quickConfigSelectedColor = Styles.color.primary;
